import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { EventsNames } from '../enums/events-names.enum';
import { ToastEnum } from '../../enums/toast.enum';
import { EventData } from '../../models/event-data';
import { EventHandlersDialogService } from '../services/event-handlers-dialog.service';
import { MarkEventAsReadService } from '../../services/mark-event-as-read.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InvolvingProcessAndPowerOfAttorneyEventHandler {
  private tradeUrlSubstring = '/bidding/';
  private eventId: number;
  private toastKey = 'involvingProcessAndPowerAttorney';

  constructor(
    private _messageService: MessageService,
    private _dialogService: EventHandlersDialogService,
    private _api: MarkEventAsReadService,
    private _router: Router,
  ) {}

  public handle(eventData: EventData, eventId: number, eventName: EventsNames): void {
    if (
      eventName === EventsNames.InvolvingProcess &&
      this._router.url.includes(this.tradeUrlSubstring)
    ) {
      return;
    }
    this.eventId = eventId;
    this._messageService.add({
      id: this.toastKey,
      sticky: true,
      styleClass:
        eventName === EventsNames.InvolvingProcess ? 'involving-process' : 'power-attorney',
      detail: eventData.shortText,
      data: {
        ...eventData,
        typeEnum: ToastEnum.involvingProcessAndPowerAttorneyToast,
        onClick: () => {
          this._dialogService.showDialog(eventData.fullText, eventName);
          this.markMessageAsRead();
        },
        onClose: (event: Event) => {
          event.stopPropagation();
          if (event.target instanceof Element) {
            event.target.closest('p-toastitem')?.remove();
          }
        },
      },
    });
  }

  public markMessageAsRead(): void {
    const sub = this._api.markMessageAsRead(this.eventId)
      .pipe(
        finalize(() => sub.unsubscribe())
      )
      .subscribe();
  }
}
